import { render } from "./hotspot-modal.vue?vue&type=template&id=63dfd1c8"
import script from "./hotspot-modal.vue?vue&type=script&lang=js"
export * from "./hotspot-modal.vue?vue&type=script&lang=js"

import "./hotspot-modal.vue?vue&type=style&index=0&id=63dfd1c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__